<div class="portlet-boundary_netxinvestorf2ScreenerNavigation_WAR_f2portlets_ screenerSelector ">
    <ul class="contain">
        <li *ngIf="isEntitledStockScreener && currentUrl ==='stocksadvanced' ; else notStocksadvanced ">
            <a class="active strong" href="javascript:void(0);" (click)="handleChildNavigation('stocksadvanced')">
                <span>{{ 'NXI_NAVIGATION.SCREENERS_NAV.STOCK_SEARCH' | pershingTranslate }}</span>
            </a>
        </li>
        <ng-template #notStocksadvanced>
            <li *ngIf="isEntitledStockScreener"><span class="icon-arrow-right icon-small"></span>
                <a href="javascript:void(0);" (click)="handleChildNavigation('stocksadvanced')">
                    <span>{{ 'NXI_NAVIGATION.SCREENERS_NAV.STOCK_SEARCH' | pershingTranslate }}</span>
                </a>
            </li>
        </ng-template>
        <li *ngIf="isEntitledETFScreener && currentUrl ==='etfadvanced' ; else notEtfadvanced ">
            <a class="active strong" href="javascript:void(0);" (click)="handleChildNavigation('etfadvanced')">
                <span>{{ 'NXI_NAVIGATION.SCREENERS_NAV.ETF_SEARCH' | pershingTranslate }}</span>
            </a>
        </li>
        <ng-template #notEtfadvanced>
            <li *ngIf="isEntitledETFScreener"><span class="icon-arrow-right icon-small"></span>
                <a href="javascript:void(0);" (click)="handleChildNavigation('etfadvanced')">
                    <span>{{ 'NXI_NAVIGATION.SCREENERS_NAV.ETF_SEARCH' | pershingTranslate }}</span>
                </a>
            </li>
        </ng-template>
        <li *ngIf="isEntitledMFScreener && currentUrl ==='mfadvanced' ; else notMfadvanced ">
            <a class="active strong" href="javascript:void(0);" (click)="handleChildNavigation('mfadvanced')">
                <span>{{ 'NXI_NAVIGATION.SCREENERS_NAV.MF_SEARCH' | pershingTranslate }}</span>
            </a>
        </li>
        <ng-template #notMfadvanced>
            <li *ngIf="isEntitledMFScreener"><span class="icon-arrow-right icon-small"></span>
                <a href="javascript:void(0);" (click)="handleChildNavigation('mfadvanced')">
                    <span>{{ 'NXI_NAVIGATION.SCREENERS_NAV.MF_SEARCH' | pershingTranslate }}</span>
                </a>
            </li>
        </ng-template>
    </ul>
</div>
<div *ngIf="currentUrl ==='mfadvanced' " class="disclaimer">
    <ul class="contain">
        {{ 'NXI_NAVIGATION.SCREENERS_MF_DISCLAIMERS.MFS_DISCLAIMER1' | pershingTranslate }}
    </ul>
    <ul class="contain">
        {{ 'NXI_NAVIGATION.SCREENERS_MF_DISCLAIMERS.MFS_DISCLAIMER2' | pershingTranslate }}
    </ul>
    <ul class="contain">
        {{ 'NXI_NAVIGATION.SCREENERS_MF_DISCLAIMERS.MFS_DISCLAIMER3' | pershingTranslate }}
    </ul>
</div>